import { ToggleSwitchChangeEvent } from 'primeng/toggleswitch';
import { DynamicField, DynamicForm, FieldVariant, SwitchFieldProps, TextFieldProps } from '../../../../components/form-builder/form-builder.types';
import { ContactRepository } from '../../../../store/contact-state/contact-state.repository';

interface getContactFormObjectProps {
  store: ContactRepository;
}

export const getContactFormObject = ({ store }: getContactFormObjectProps): DynamicForm => {
  const nomColumn: DynamicField<TextFieldProps> = {
    label: 'settings.contact.form.name.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      value: store.getNestedObservable<string>('dto', 'nom'),
      onChange: (value: string) => store.setNested('dto', 'nom', value),
    },
  };
  const emailColumn: DynamicField<TextFieldProps> = {
    label: 'settings.contact.form.email.label',
    variant: FieldVariant.EMAIL,
    isRequired: true,
    props: {
      value: store.getNestedObservable<string>('dto', 'email'),
      onChange: (value: string) => store.setNested('dto', 'email', value),
    },
  };
  const addressColumn: DynamicField<TextFieldProps> = {
    label: 'settings.contact.form.address.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    props: {
      value: store.getNestedObservable<string>('dto', 'address'),
      onChange: (value: string) => store.setNested('dto', 'address', value),
    },
  };

  const tel1Column: DynamicField<TextFieldProps> = {
    label: 'settings.contact.form.phone1.label',
    variant: FieldVariant.TEL,
    isRequired: true,
    props: {
      value: store.getNestedObservable<string>('dto', 'tel1'),
      onChange: (value: string) => store.setNested('dto', 'tel1', value),
    },
  };
  const tel2Column: DynamicField<TextFieldProps> = {
    label: 'settings.contact.form.phone2.label',
    variant: FieldVariant.TEL,
    isRequired: true,
    props: {
      value: store.getNestedObservable<string>('dto', 'tel2'),
      onChange: (value: string) => store.setNested('dto', 'tel2', value),
    },
  };

  const isLegalRepresentativeColumn: DynamicField<SwitchFieldProps> = {
    label: 'settings.contact.form.legalRepresentation.label',
    variant: FieldVariant.SWITCH,
    isRequired: true,
    props: {
      placeholder: 'settings.contact.form.legalRepresentation.placeholder',
      checked: store.getNestedObservable<boolean>('companyContactExtraDto', 'representantLegal'),
      onChange: (value: ToggleSwitchChangeEvent) => store.setNested('companyContactExtraDto', 'representantLegal', value.checked),
    },
  };

  const isPrincipalColumn: DynamicField<SwitchFieldProps> = {
    label: 'settings.contact.form.principal.label',
    variant: FieldVariant.SWITCH,
    isRequired: true,
    props: {
      placeholder: 'settings.contact.form.principal.placeholder',
      checked: store.getNestedObservable<boolean>('companyContactExtraDto', 'principal'),
      onChange: (value: ToggleSwitchChangeEvent) => store.setNested('companyContactExtraDto', 'principal', value.checked),
    },
  };

  return {
    title: 'Contact',
    description: '',
    isHeaderHidden: true,
    orientation: 'horizontal',
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [nomColumn],
          },
          {
            fields: [emailColumn],
          },
          {
            fields: [isLegalRepresentativeColumn],
          },
          {
            fields: [isPrincipalColumn],
          },
          {
            fields: [addressColumn],
          },
          {
            fields: [tel1Column, tel2Column],
          },
        ],
      },
    ],
  };
};
